export enum AdminMarketplaceTab {
    Engagements = 1,
    TimelineTemplates = 2,
    MarketplaceBuyers = 3,
    MarketplaceBrokers = 6,
    DocumentTemplates = 4,
    MarketplaceSettings = 5,
    MarketplaceBuyerNdas = 7,
    SupportMeetings = 8,
    LegalIssuesGuidance = 9,
    AdditionalNdaCovenants = 10,
}

export const AdminMarketplaceTabs = [
    { id: AdminMarketplaceTab.Engagements, content: 'Engagements' },
    {
        id: AdminMarketplaceTab.TimelineTemplates,
        content: 'Timeline Templates',
    },
    { id: AdminMarketplaceTab.MarketplaceBuyers, content: 'Buyers' },
    { id: AdminMarketplaceTab.MarketplaceBrokers, content: 'Advisors' },
    {
        id: AdminMarketplaceTab.DocumentTemplates,
        content: 'Document Templates',
    },
    {
        id: AdminMarketplaceTab.MarketplaceBuyerNdas,
        content: 'Marketplace Buyer NDAs',
    },
    {
        id: AdminMarketplaceTab.MarketplaceSettings,
        content: 'Marketplace Settings',
    },
    {
        id: AdminMarketplaceTab.SupportMeetings,
        content: 'Support Meetings',
    },
    {
        id: AdminMarketplaceTab.LegalIssuesGuidance,
        content: 'Legal Issues Guidance',
    },
    {
        id: AdminMarketplaceTab.AdditionalNdaCovenants,
        content: 'Additional NDA Covenants',
    },
];
